module.exports = __webpack_public_path__ + "img/ic_back.9137ef7d.svg";